var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"show":_vm.showing},on:{"update:show":function($event){_vm.showing=$event}}},[(_vm.showing)?_c('FullRolodex',{attrs:{"request-id":_vm.requestId},on:{"select":function($event){return _vm.$emit('select', $event)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }